const swipeHandler = (element, cb, preventScroll, moveCb) => {
  let startX = 0;
  let endX = 0;
  let startY = 0;
  let endY = 0;
  let touches = [];
  const handleTouchStart = (e) => {
    startX = e.changedTouches[0].pageX;
    startY = e.changedTouches[0].pageY;
  };
  const handleTouchEnd = (e) => {
    endX = e.changedTouches[0].pageX;
    endY = e.changedTouches[0].pageY;
    const deltaY = Math.abs(endY - startY);
    const deltaX = Math.abs(endX - startX);
    if (deltaY < 50 && deltaX > 50) {
      if (startX > endX) cb("swipeLeft");
      if (startX < endX) cb("swipeRight");
    } else {
      cb("none");
    }
    touches = [];
  };
  const handleTouchMove = (e) => {
    const delta = e.changedTouches[0].clientX - startX;
    if (moveCb) moveCb(delta);
    touches.push(e.changedTouches[0]);
  };
  const handleTouchCancel = () => {
    touches = [];
  };
  element.addEventListener("touchstart", handleTouchStart, { passive: preventScroll === false });
  element.addEventListener("touchend", handleTouchEnd, { passive: preventScroll === false });
  element.addEventListener("touchmove", handleTouchMove, { passive: preventScroll === false });
  element.addEventListener("touchcancel", handleTouchCancel, { passive: preventScroll === false });
  const cleanUp = () => {
    element.removeEventListener("touchstart", handleTouchStart);
    element.removeEventListener("touchend", handleTouchEnd);
    element.removeEventListener("touchmove", handleTouchMove);
    element.removeEventListener("touchcancel", handleTouchCancel);
  };
  return cleanUp;
};
export {
  swipeHandler as default
};
//# sourceMappingURL=swipe.mjs.map
